import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { MustMatchDirective } from '../../directives/must-match.directive';

@Component({
  selector: 'reset-password',
  standalone: true,
  imports: [FormsModule, RouterModule, MustMatchDirective],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css',
})
export class ResetPasswordComponent implements OnInit {
  token: String | null = null;
  isLinkExpired: boolean = true;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    if (this.token) {
      this.isValidToken(this.token);
    }
  }

  onSubmit(frm: NgForm): void {
    let credential = frm.value;
    credential.token = this.token;

    this.spinner.show();
    this.authService.resetPassword(credential).subscribe(
      (response) => {
        this.spinner.hide();
        this.toastr.success(response.message.Text, 'Reset Password');
        this.router.navigate(['/login']);
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error.error.message.Text, 'Reset Password');
      }
    );
  }

  isValidToken(token: String): void {
    this.authService.isLinkExpired(token).subscribe(
      (response) => {
        this.spinner.hide();
        this.isLinkExpired = response.data.isExipred;
      },
      (error) => {
        this.spinner.hide();
        console.error(error);
      }
    );
  }
}
